module.exports = __webpack_public_path__ + "static/media/supplier.50b6324a.svg";